import React from "react";

import { Modal as DSModal, type ModalProps } from "@packages/ds";

/**
 * Console app wrapper for the Modal component.
 * Maintains backward compatibility with existing code.
 *
 * @deprecated Use the Modal component from @packages/ds directly instead
 * @example
 * // Instead of:
 * import Modal from "ds/Modal";
 *
 * // Use:
 * import { Modal } from "@packages/ds";
 */
export const Modal = Object.assign(
  (props: ModalProps) => {
    return React.createElement(DSModal, props);
  },
  // Copy all subcomponents from the DS Modal
  DSModal
);

/**
 * @deprecated Use named import { Modal } from "@packages/ds" instead
 */
export default Modal;

/**
 * @deprecated Use { Modal } from "@packages/ds" and access via Modal.Root instead
 */
export const Root = DSModal.Root;

/**
 * @deprecated Use { Modal } from "@packages/ds" and access via Modal.Trigger instead
 */
export const Trigger = DSModal.Trigger;

/**
 * @deprecated Use { Modal } from "@packages/ds" and access via Modal.Portal instead
 */
export const Portal = DSModal.Portal;

/**
 * @deprecated Use { Modal } from "@packages/ds" and access via Modal.Close instead
 */
export const Close = DSModal.Close;

/**
 * @deprecated Use { Modal } from "@packages/ds" and access via Modal.Content instead
 */
export const Content = DSModal.Content;

/**
 * @deprecated Use { Modal } from "@packages/ds" and access via Modal.Overlay instead
 */
export const Overlay = DSModal.Overlay;

/**
 * @deprecated Use { Modal } from "@packages/ds" and access via Modal.CloseButton instead
 */
export const CloseButton = DSModal.CloseButton;
